import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { observer } from 'mobx-react-lite'
import { CopyRight2, Download, LinkAngled } from 'blaze-ui/icons'
import { useDesignDownload } from './useDesignDownload'
import { DesignDownloadBody } from './DesignDownloadBody'
import Styles from './DesignDownloadModal.module.scss'
import { useRootStore } from 'stores/RootStore'

interface Props {
  fileId?: string
  showBackButton?: boolean
}

const DesignDownloadModal = observer(({ fileId, showBackButton = false }: Props) => {
  const { designStore } = useRootStore()
  const { closeModal } = useModals()
  const {
    isDownloading,
    handleSubmit,
    handleShare,
    isLoading,
    handleCopyToClipboard,
    previews,
    exportFiles,
    handleSingleDownload,
    framesCount,
  } = useDesignDownload({ fileId })

  return (
    <Modal.Root onPressOutside={closeModal}>
      <Modal.Header
        title={
          <>
            {showBackButton && <Modal.BackButton onPress={closeModal} />}
            Export Design
          </>
        }
        actions={
          <>
            {!!designStore?.captionsStore.caption.length && (
              <Button frontIcon={CopyRight2} variant="tertiary" onPress={handleCopyToClipboard}>
                Copy Text to Clipboard
              </Button>
            )}
          </>
        }
      />
      <Modal.Content>
        <DesignDownloadBody
          downloadsCount={framesCount}
          previews={previews}
          exportFiles={exportFiles}
          onPress={handleSingleDownload}
        />
      </Modal.Content>
      <Modal.Footer blaze>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal} isDisabled={isDownloading || isLoading}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.rightButtons}>
            <Button
              size="lg"
              onPress={handleShare}
              variant="tertiary"
              isDisabled={isDownloading || isLoading}
              frontIcon={LinkAngled}
            >
              Copy Link
            </Button>
            <Button
              size="lg"
              onPress={() => handleSubmit()}
              isDisabled={isDownloading || isLoading}
              frontIcon={Download}
            >
              {exportFiles.length > 1 ? `Download All ${exportFiles.length} Files` : 'Download'}
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
})

export { DesignDownloadModal }
